import { render } from "./BaseLayout.vue?vue&type=template&id=b7d9c444"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=b7d9c444&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__